var paragraph_default = {
  "fontElementMap": "K-ko3",
  "elementSpacing": "l-P5G",
  "text": "_01XM8 l-P5G",
  "child": "BrKEk"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
